module.exports = __webpack_public_path__ + "static/media/YF01_2.c5585b96.jpg";